import {BehaviorSubject} from 'rxjs';
import {ProfileModel} from '../views/models/profile.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  profile_change$ = new BehaviorSubject<ProfileModel[]>(undefined);
  checkin_profile_change$ = new BehaviorSubject<ProfileModel[]>([]);


  constructor(private httpClient: HttpClient) {
  }

  getProfiles() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/profiles').subscribe(
      (profiles: ProfileModel[]) => {
        this.profile_change$.next(profiles);
      }
    );
  }

  getProfilebyID(id: string) {
    return this.httpClient.get(environment.baseURL + '/v2/api' + '/profile/' + id);
  }

  putProfile(profile: ProfileModel) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/app_me/' + profile.id, profile).subscribe(
      () => {
        this.getProfiles();
      }, (err) => console.log(err)
    );
  }

  checkinList() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/online_check_in').subscribe(
      (profiles: ProfileModel[]) => {
        this.checkin_profile_change$.next(profiles);
      }
    );
  }
}
